"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fselect = exports.Finput = exports.createRenderer = exports.genericProps = exports.useAsyncValidator = exports.FormArray = exports.FormValidAndDirty = exports.useControlStateComponent = exports.useControlStateVersion = exports.useControlValue = exports.useControlState = exports.useControlChangeEffect = void 0;
var react_1 = __importStar(require("react"));
var nodes_1 = require("./nodes");
function useControlChangeEffect(control, changeEffect, mask, deps) {
    var updater = react_1.useMemo(function () { return changeEffect; }, deps !== null && deps !== void 0 ? deps : [control]);
    react_1.useEffect(function () {
        control.addChangeListener(updater, mask);
        return function () { return control.removeChangeListener(updater); };
    }, [updater]);
}
exports.useControlChangeEffect = useControlChangeEffect;
function useControlState(control, toState, mask) {
    var _a = react_1.useState(function () { return toState(control); }), state = _a[0], setState = _a[1];
    react_1.useEffect(function () {
        setState(function (p) { return toState(control, p); });
    }, [control]);
    useControlChangeEffect(control, function (control) { return setState(function (p) { return toState(control, p); }); }, mask);
    return state;
}
exports.useControlState = useControlState;
function useControlValue(control, mask) {
    return useControlState(control, function (n) { return n.value; }, mask);
}
exports.useControlValue = useControlValue;
function useControlStateVersion(control, mask) {
    return useControlState(control, function (c) { return c.stateVersion; }, mask);
}
exports.useControlStateVersion = useControlStateVersion;
function useControlStateComponent(control, toState, mask) {
    return react_1.useMemo(function () { return function (_a) {
        var children = _a.children;
        var state = useControlState(control, toState, mask);
        return children(state);
    }; }, []);
}
exports.useControlStateComponent = useControlStateComponent;
function FormValidAndDirty(_a) {
    var state = _a.state, children = _a.children;
    var validForm = useControlState(state, function (c) { return c.valid && c.dirty; }, nodes_1.ControlChange.Valid | nodes_1.ControlChange.Dirty);
    return children(validForm);
}
exports.FormValidAndDirty = FormValidAndDirty;
function FormArray(_a) {
    var state = _a.state, children = _a.children;
    useControlState(state, function (c) { return c.elems; }, nodes_1.ControlChange.Value);
    return react_1.default.createElement(react_1.default.Fragment, null, children(state.elems));
}
exports.FormArray = FormArray;
function defaultValidCheck(n) {
    return n instanceof nodes_1.FormControl ? n.value : n.stateVersion;
}
function useAsyncValidator(control, validator, delay, validCheckValue) {
    var handler = react_1.useRef();
    var abortController = react_1.useRef();
    var validCheck = validCheckValue !== null && validCheckValue !== void 0 ? validCheckValue : defaultValidCheck;
    useControlChangeEffect(control, function (n) {
        if (handler.current) {
            window.clearTimeout(handler.current);
        }
        if (abortController.current) {
            abortController.current.abort();
        }
        var currentVersion = validCheck(n);
        handler.current = window.setTimeout(function () {
            var aborter = new AbortController();
            abortController.current = aborter;
            validator(n, aborter.signal)
                .then(function (error) {
                if (validCheck(n) === currentVersion) {
                    n.setTouched(true);
                    n.setError(error);
                }
            })
                .catch(function (e) {
                if (!(e instanceof DOMException && e.code == DOMException.ABORT_ERR)) {
                    throw e;
                }
            });
        }, delay);
    }, nodes_1.ControlChange.Value | nodes_1.ControlChange.Validate);
}
exports.useAsyncValidator = useAsyncValidator;
function genericProps(state) {
    return {
        ref: function (elem) {
            state.element = elem;
        },
        value: state.value,
        disabled: state.disabled,
        errorText: state.touched && !state.valid ? state.error : undefined,
        onBlur: function () { return state.setTouched(true); },
        onChange: function (e) { return state.setValue(e.target.value); },
    };
}
exports.genericProps = genericProps;
function createRenderer(render, mask) {
    return function (props) {
        useControlStateVersion(props.state, mask);
        return render(props, genericProps(props.state));
    };
}
exports.createRenderer = createRenderer;
function Finput(_a) {
    var state = _a.state, others = __rest(_a, ["state"]);
    // Re-render on value or disabled state change
    useControlStateVersion(state, nodes_1.ControlChange.Value | nodes_1.ControlChange.Disabled);
    // Update the HTML5 custom validity whenever the error message is changed/cleared
    useControlChangeEffect(state, function (s) { var _a, _b; return (_a = state.element) === null || _a === void 0 ? void 0 : _a.setCustomValidity((_b = state.error) !== null && _b !== void 0 ? _b : ""); }, nodes_1.ControlChange.Error);
    var theseProps = genericProps(state);
    return (react_1.default.createElement("input", __assign({}, theseProps, { ref: function (r) {
            var _a;
            state.element = r;
            if (r)
                r.setCustomValidity((_a = state.error) !== null && _a !== void 0 ? _a : "");
        } }, others)));
}
exports.Finput = Finput;
function Fselect(_a) {
    var state = _a.state, children = _a.children, others = __rest(_a, ["state", "children"]);
    // Re-render on value or disabled state change
    useControlStateVersion(state, nodes_1.ControlChange.Value | nodes_1.ControlChange.Disabled);
    // Update the HTML5 custom validity whenever the error message is changed/cleared
    useControlChangeEffect(state, function (s) { var _a, _b; return (_a = s.element) === null || _a === void 0 ? void 0 : _a.setCustomValidity((_b = state.error) !== null && _b !== void 0 ? _b : ""); }, nodes_1.ControlChange.Error);
    var theseProps = genericProps(state);
    return (react_1.default.createElement("select", __assign({}, theseProps, { ref: function (r) {
            var _a;
            state.element = r;
            if (r)
                r.setCustomValidity((_a = state.error) !== null && _a !== void 0 ? _a : "");
        } }, others), children));
}
exports.Fselect = Fselect;
